import { Building2, Calendar, Tag } from "lucide-react";
import { clients } from "../data/sampleData";

const statusConfig = {
  active: { label: "契約中", color: "#10b981", bg: "rgba(16,185,129,0.15)" },
  trial: { label: "トライアル", color: "#f59e0b", bg: "rgba(245,158,11,0.15)" },
  negotiating: { label: "商談中", color: "#6366f1", bg: "rgba(99,102,241,0.15)" },
};

export default function ClientCards() {
  return (
    <section>
      <h2 className="section-title">クライアント一覧</h2>
      <div className="cards-grid">
        {clients.map((c) => {
          const s = statusConfig[c.status];
          return (
            <div key={c.id} className="card client-card">
              <div className="card-header">
                <Building2 size={18} color="#6366f1" />
                <span className="status-badge" style={{ color: s.color, background: s.bg }}>
                  {s.label}
                </span>
              </div>
              <h3 className="client-name">{c.company}</h3>
              <div className="client-meta">
                <span><Tag size={13} /> {c.industry}</span>
                <span><Calendar size={13} /> {c.contractDate}</span>
              </div>
              {c.revenue > 0 && (
                <div className="client-revenue">
                  ¥{c.revenue.toLocaleString()}<span>/月</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
